module.exports = __webpack_public_path__ + "supplier/img/login-pic.882f65a8.png";